import { Bits } from './bits';

export enum InfluencerPermissions {
	FullAccess = Bits.Bit1,
	SearchResults = Bits.Bit2
}
